module.exports = __webpack_public_path__ + "static/media/dtj-logos-2.61448c07.jpg";